import Vue from 'vue';
import MutationType from 'Models/MutationTypeModel';
import { parseOrders } from 'Root/helpers/admin';

// eslint-disable-next-line import/prefer-default-export
export function mutateEntity(state, { entity, data, type }) {
  if (state[entity] === data) {
    return;
  }

  let newData = null;

  if (Array.isArray(state[entity])) {
    const _data = Array.isArray(data) ? [...data] : [data];

    if (type === MutationType.PUSH) {
      newData = [...state[entity], ..._data];
    } else if (type === MutationType.UNSHIFT) {
      newData = [..._data, ...state[entity]];
    } else if (type === MutationType.DELETE_KEY) {
      if (typeof state[entity] === 'undefined') {
        return;
      }

      Vue.delete(state[entity], data);
      return;
    } else {
      newData = [..._data];
    }
  } else if (typeof state[entity] === 'object'
    && typeof data === 'object'
    && data) { /* Проверка на объект и не null */
    if (type === MutationType.PUSH) {
      newData = { ...state[entity], ...data };
    } else {
      newData = { ...data };
    }
  } else if (type === MutationType.DELETE_KEY) {
    if (typeof state[entity] === 'undefined') {
      return;
    }

    Vue.delete(state[entity], data);
    return;
  } else {
    newData = data;
  }

  Vue.set(state, entity, newData);
}

export function mutateNestedEntity(state, {
  entity, nestedEntity, data, type,
}) {
  mutateEntity(state[entity], { entity: nestedEntity, data, type });
}

export function mutateEntityWithParseOrders(state, { entity, data, type }) {
  mutateEntity(state, { entity, data: parseOrders(data), type });
}

export function mutateEntityWithFindIndex(state, {
  entity, id, field, value,
}) {
  const targetIndex = state[entity].findIndex((u) => u.id === id);
  if (targetIndex > -1) {
    Vue.set(state[entity][targetIndex], field, value);
  }
}
